// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table__item-style[data-v-ae0c0d7e] {\n  margin: 0.3125rem 0;\n}\n[data-v-ae0c0d7e] .el-radio__inner {\n  width: 1.125rem;\n  height: 1.125rem;\n  border-color: #909399;\n}\n[data-v-ae0c0d7e] .el-radio__input.is-checked .el-radio__inner::after {\n  width: 0.375rem;\n  height: 0.375rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
